import { editUser } from 'utils/modals';
import i18n from 'i18n/config';
import { deletePartner } from 'modules/partners/utils/deletePartner';

export default [
  {
    icon: 'ni-eye',
    text: i18n.t('Watch'),
    url: '/detalle-socio',
  },
  {
    icon: 'ni-edit',
    text: i18n.t('Edit'),
    action: editUser,
    dontShowCurrent: ({ isReadOnly, isReadOnlyUser }) =>
      isReadOnly === true || isReadOnlyUser === true,
  },
  {
    icon: 'ni-trash',
    text: i18n.t('Delete'),
    action: async ({ data }) => {
      await deletePartner({ data });
    },
    dontShowCurrent: ({ isReadOnly, isReadOnlyUser }) =>
      isReadOnly === true || isReadOnlyUser === true,
  },
];
